export { FacetAccordionBlock } from "./facet-accordion";
